import axios from 'axios';
import {buildQuery} from 'utils/QueryUtils';

export const findOrganizations = (headers, params) => {
  let query = buildQuery(params);
  return axios.get(
    `${process.env.REACT_APP_INFO_API_URL}/organizations${query}`,
    {
      headers,
    },
  );
};

export const findOrganizationById = (headers, id) => {
  return axios.get(
    `${process.env.REACT_APP_INFO_API_URL}/organizations/${id}`,
    {
      headers,
    },
  );
};

export const createOrganization = (headers, data) => {
  return axios.post(
    `${process.env.REACT_APP_INFO_API_URL}/organizations`,
    data,
    {
      headers,
    },
  );
};

export const updateOrganization = (headers, id, data) => {
  return axios.patch(
    `${process.env.REACT_APP_INFO_API_URL}/organizations/${id}`,
    data,
    {
      headers,
    },
  );
};

export const deleteOrganization = (headers, id) => {
  return axios.delete(
    `${process.env.REACT_APP_INFO_API_URL}/organizations/${id}`,
    {
      headers: headers,
    },
  );
};
